import { render, staticRenderFns } from "./BranchesSummary.vue?vue&type=template&id=3d0a872c&scoped=true&"
import script from "./BranchesSummary.vue?vue&type=script&lang=ts&"
export * from "./BranchesSummary.vue?vue&type=script&lang=ts&"
import style0 from "./BranchesSummary.vue?vue&type=style&index=0&id=3d0a872c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0a872c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VRow})
